import { render, staticRenderFns } from "./CVDTable.vue?vue&type=template&id=fa40bc6e&"
import script from "./CVDTable.js?vue&type=script&lang=js&"
export * from "./CVDTable.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports